export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '任务剩余时间',
		align: 'center',
		dataIndex: 'endEffectTimeStr',
		scopedSlots: { customRender: 'endEffectTimeStr' },
	},
	{
		title: '下单日期',
		align: 'center',
		dataIndex: 'orderCreateTime',
		scopedSlots: { customRender: 'orderCreateTime' },
	},
	{
		title: '审核人',
		align: 'center',
		dataIndex: 'checkorName',
		scopedSlots: { customRender: 'checkorName' },
	},
	{
		title: '订单号',
		align: 'center',
		dataIndex: 'orderNo',
	},
	{
		title: '报案号',
		align: 'center',
		dataIndex: 'caseNo',
	},
	{
		title: '服务公司',
		align: 'center',
		dataIndex: 'partnerName',
	},
	{
		title: '作业人员',
		align: 'center',
		dataIndex: 'visitorName',
	},
	{
		title: '伤者姓名',
		align: 'center',
		dataIndex: 'injuredName',
	},
	{
		title: '作业所在地区',
		align: 'center',
		dataIndex: 'location',
	},

	{
		title: '订单状态',
		align: 'center',
		dataIndex: 'orderStatus',
		scopedSlots: { customRender: 'orderStatus' },
	},
	{
		title: '操作',
		align: 'center',
		dataIndex: 'revisitType',
		key: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
